/**
 * Destek kanalları — giriş ekranındaki "Yardıma ihtiyacın var mı?" penceresi ile
 * uygulama içindeki üç Yardım sayfasının ORTAK kaynağı.
 *
 * Numara daha önce student/teacher/parent Help.tsx dosyalarında üç kez ayrı ayrı
 * yazılıydı. Giriş ekranı dördüncü kopyayı almasın diye buraya çıkarıldı: destek
 * hattı değiştiğinde tek satır değişmeli, yoksa giriş ekranı sessizce eski
 * numarayı göstermeye devam eder — üstelik tam da kullanıcının kimseye
 * ulaşamadığı an olduğu için yanlışlığın fark edilmesi en zor yer orası.
 */

export const WHATSAPP_SUPPORT = '+90 530 799 32 71';

// wa.me opens the WhatsApp app directly (or web.whatsapp.com on desktop) —
// a tel: link would just open a dial pad, which is not what "destek hattı" means here.
export const WHATSAPP_LINK = 'https://wa.me/905307993271';

export interface SupportChannel {
  id: string;
  /** Kanalın adı — "WhatsApp destek hattı" gibi. */
  label: string;
  /** Ekranda gösterilen değer (numara, adres…). */
  value: string;
  href: string;
  /** Bir satırlık açıklama; ne için kullanılacağını söyler. */
  hint?: string;
}

/**
 * Giriş ekranındaki yardım penceresi bu listeyi dolaşarak çizer, yani yeni bir
 * kanal (e-posta, telefon, ikinci bir WhatsApp hattı) eklemek için buraya bir
 * satır eklemek yeterli — pencerede JSX değişikliği gerekmez.
 */
export const SUPPORT_CHANNELS: SupportChannel[] = [
  {
    id: 'whatsapp',
    label: 'WhatsApp destek hattı',
    value: WHATSAPP_SUPPORT,
    href: WHATSAPP_LINK,
    hint: 'Teknik sorunlar için destek ekibimize yazın',
  },
];
